
<label>
    <span>Lignes par page : </span>
    <kal-select [formControl]="pageSizeControl">
        <kal-option [value]="rows" *ngFor="let rows of rowsByPageList">{{ rows }}</kal-option>
    </kal-select>
</label>

<nav *ngIf="pagesList?.length > 1 else singlePageTemplate">
    <a *ngIf="current > 0" class="nextprev" (click)="prev()">
        <kal-icon>arrow_back</kal-icon>
        <span>Page précédente</span>
    </a>

    <!-- on affiche première page si :
         * la première page affichée est plus grande que la première page
      -->
    <ng-container *ngIf="pagesList[0] > 0">
        <a (click)="goTo(0)">1</a> ...
    </ng-container>

    <ng-container *ngFor="let p of pagesList; let last=last">
        <a [class.active]="p === current" (click)="goTo(p)">{{ p + 1  }}</a>
        <span *ngIf="!last"> - </span>
    </ng-container>

    <!-- on affiche dernière page si:
         * la dernière page affichée est plus petite que la dernière page
          -->
    <ng-container *ngIf="pagesList[pagesToDisplay-1] < lastPage ">
        ... <a (click)="goTo(lastPage)">{{ lastPage + 1 }}</a>
    </ng-container>

    <a *ngIf="current < lastPage" class="nextprev" (click)="next()">
        <span>Page suivante </span>
        <kal-icon>arrow_forward</kal-icon>
    </a>
</nav>

<ng-template #singlePageTemplate>
    Page 1/1
</ng-template>
